import { RootState } from "@/app/stores";
import { createSelector } from "@reduxjs/toolkit";

const baseMarketingCampaignsSelector = createSelector(
    (state: RootState) => state,
    (state) => state.marketingCampaigns
)

export const selectMarketingCampaigns = createSelector(
    baseMarketingCampaignsSelector,
    (state) => state.campaigns
)

export const selectMarketingCampaignsLoading = createSelector(
    baseMarketingCampaignsSelector,
    (state) => state.isCampaignsLoading
)

export const selectMarketingCampaignsFirstLoad = createSelector(
    baseMarketingCampaignsSelector,
    (state) => state.isCampaignsFirstLoad
)

export const selectMarketingCampaignsError = createSelector(
    baseMarketingCampaignsSelector,
    (state) => state.campaignsError
)

export const selectChannels = createSelector(
    baseMarketingCampaignsSelector,
    (state) => state.channels
)

export const selectChannelsLoading = createSelector(
    baseMarketingCampaignsSelector,
    (state) => state.isChannelsLoading
)

export const selectChannelsFirstLoad = createSelector(
    baseMarketingCampaignsSelector,
    (state) => state.isChannelsFirstLoad
)

export const selectChannelsError = createSelector(
    baseMarketingCampaignsSelector,
    (state) => state.channelsError
)

export const selectCurrentSearch = createSelector(
    baseMarketingCampaignsSelector,
    (state) => state.search
)

export const selectCurrentPage = createSelector(
    baseMarketingCampaignsSelector,
    (state) => state.page
)

export const selectTotalPages = createSelector(
    baseMarketingCampaignsSelector,
    (state) => state.totalPages
)

const baseMarketingCampaignSelector = createSelector(
    (state: RootState) => state,
    (state) => state.marketingCampaign
)

export const selectMarketingCampaign = createSelector(
    baseMarketingCampaignSelector,
    (state) => state.campaign
)

export const selectMarketingCampaignLoading = createSelector(
    baseMarketingCampaignSelector,
    (state) => state.isLoading
)

export const selectMarketingCampaignError = createSelector(
    baseMarketingCampaignSelector,
    (state) => state.error
)

export const selectPrizes = createSelector(
    baseMarketingCampaignSelector,
    (state) => state.prizes
)

export const selectPrizesLoading = createSelector(
    baseMarketingCampaignSelector,
    (state) => state.isPrizesLoading
)

export const selectPrizesFirstLoad = createSelector(
    baseMarketingCampaignSelector,
    (state) => state.isPrizesFirstLoad
)

export const selectPrizesPage = createSelector(
    baseMarketingCampaignSelector,
    (state) => state.prizesPage
)

export const selectPrizesTotalPages = createSelector(
    baseMarketingCampaignSelector,
    (state) => state.prizesTotalPages
)

export const selectParticipations = createSelector(
    baseMarketingCampaignSelector,
    (state) => state.participations
)

export const selectParticipationsLoading = createSelector(
    baseMarketingCampaignSelector,
    (state) => state.isParticipationsLoading
)

export const selectParticipationsFirstLoad = createSelector(
    baseMarketingCampaignSelector,
    (state) => state.isParticipationsFirstLoad
)

export const selectParticipationsPage = createSelector(
    baseMarketingCampaignSelector,
    (state) => state.participationsPage
)

export const selectParticipationsTotalPages = createSelector(
    baseMarketingCampaignSelector,
    (state) => state.participationsTotalPages
)

export const selectMarketingCampaignStatistics = createSelector(
    baseMarketingCampaignSelector,
    (state) => state.campaignStatistics
)

export const selectParticipationsCount = createSelector(
    baseMarketingCampaignSelector,
    (state) => state.participationsCount
)

export const selectRegistrationsCount = createSelector(
    baseMarketingCampaignSelector,
    (state) => state.registrationsCount
)